import React, { useEffect, useState, useRef, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { DJCPService, UserService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import DJCP from './DJCP';
import DJCPPrint from '../DJCPPrint/DJCPPrint';
import { useReactToPrint } from 'react-to-print';
import { formatCoordinates } from '../../helpers';

//Estilos

function DJCPContainer() {
    const {
        user,
        token,
        masters,
        toast,
        grapesVariety,
        settings,
        formatNumber,
    } = useGlobalContext();

    const [loader, setLoader] = useState(false);
    const [openInhabModal, setOpenInhabModal] = useState(false);
    const [inhabilitateDJCP, setInhabilitateDJCP] = useState(false);
    const [watchDJCPLogs, setWatchDJCPLogs] = useState(false);
    const [Coordinates, setCoordinates] = useState({});
    const [DJCPData, setDJCPData] = useState({});

    const Params = useParams();
    const PrintRef = useRef();

    const InhabModalContent = (
        <footer>
            <button
                className="btn btn-primary"
                onClick={() => handleInhabDJCPSubmit()}
            >
                Aceptar
            </button>
            <button
                className="btn btn-secondary"
                onClick={() => setOpenInhabModal(false)}
            >
                Cancelar
            </button>
        </footer>
    );

    //Formateador de coordenadas
    useEffect(() => {
        if (Object.keys(DJCPData).length > 0) {
            formatCoordinates(
                DJCPData.cabecera.ubicacion_X,
                DJCPData.cabecera.ubicacion_Y
            ).then((res) =>
                setCoordinates({
                    lat: res[0],
                    lon: res[1],
                })
            );
        }
    }, [DJCPData]);

    useEffect(() => {
        const getMyDJCP = async () => {
            try {
                setLoader(true);

                //Obtenemos la DJCP segun el id que esta en los params
                const myDJCPs = await DJCPService.single({
                    token,
                    id: parseInt(Params.id),
                });

                //Si la respuesta es correcta seteamos el estado de myDJCP con los datos de la respuesta
                if (myDJCPs) {
                    const getNombreUsuario = await UserService.getNombreUsuario(
                        { token, usuarioId: myDJCPs.data.cabecera.usuario }
                    );

                    if (getNombreUsuario) {
                        setDJCPData({
                            ...myDJCPs.data,
                            ...getNombreUsuario.data,
                        });
                    }
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };
        const getInhabDJCPBool = async () => {
            try {
                setLoader(true);
                //Averiguamos si la DJCP tiene guias
                const DJCPHasGuia = await DJCPService.inhab({
                    token,
                    id: parseInt(Params.id),
                    inhabilitar: false,
                });

                if (DJCPHasGuia) {
                    setInhabilitateDJCP(DJCPHasGuia.data);
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getMyDJCP();
        getInhabDJCPBool();
    }, [Params.id, inhabilitateDJCP]);

    const handleInhabDJCPSubmit = async () => {
        try {
            setLoader(true);
            //Deshabilitamos la DJCP
            const DJCPHasGuia = await DJCPService.inhab({
                token,
                id: parseInt(Params.id),
                inhabilitar: true,
            });

            if (DJCPHasGuia) {
                toast('DJCP inhabilitada con éxito', { type: 'success' });
                setInhabilitateDJCP(DJCPHasGuia.data);
                setOpenInhabModal(false);
            }
            setLoader(false);
        } catch (err) {
            setLoader(false);
            setOpenInhabModal(false);
            return err;
        }
    };

    //Funciones para imprimir la guia
    const handlePrint = useReactToPrint({
        content: () => PrintRef.current,
    });

    return loader ? (
        <Spinner />
    ) : (
        <>
            <DJCP
                functions={{
                    formatNumber,
                    setWatchDJCPLogs,
                    handlePrint,
                    handleInhabDJCPSubmit,
                    setOpenInhabModal,
                }}
                states={{
                    watchDJCPLogs,
                    DJCPData,
                    masters,
                    inhabilitateDJCP,
                    Coordinates,
                }}
            />
            <DJCPPrint
                reference={PrintRef}
                functions={{
                    formatNumber,
                }}
                states={{
                    user,
                    DJCPData,
                    masters,
                    grapesVariety,
                    settings,
                    Coordinates,
                }}
            />
            <Modal
                title={'¿Está seguro que desea deshabilitar la DJCP?'}
                questionModal
                isOpen={openInhabModal}
                onClose={() => setOpenInhabModal(false)}
            >
                {InhabModalContent}
            </Modal>
        </>
    );
}

export default DJCPContainer;
